const dummy_t = (translationKey) => translationKey;

export default [
  {
    path: '/lab-tests',
    translationKey: dummy_t('menu.labTests'),
  },
  {
    path: '/tracker',
    translationKey: dummy_t('menu.tracker'),
  },
  {
    path: '/achievements',
    translationKey: dummy_t('menu.achievements'),
  },
  {
    path: '/meals',
    translationKey: dummy_t('menu.diet'),
  },
  {
    path: '/knowledge',
    translationKey: dummy_t('menu.knowledge'),
  },
  {
    path: '/measurements',
    translationKey: dummy_t('menu.measurements'),
  },
  {
    path: '/hydration',
    translationKey: dummy_t('menu.hydration'),
  },
  // {
  //   path: 'sample-path',
  //   translationKey: 'menu/sample',
  //   disabled: true,
  // },
];
